import { reactive, getCurrentInstance, ref } from 'vue'
import { parseScanCodeUtils, getValueByPath } from 'pangu-core'

export function useScan({ data, emit, emitInput = false, changeDisabled }) {
  const { proxy } = getCurrentInstance()

  const __data = reactive({
    success: false,
    origin: null,
    codeType: null,
    print: null,
    data: new Map(),
    // 单次扫码的结果
    current: new Map(),
  })

  // 扫码枪标识
  let __mark = []
  // 扫码枪默认标识
  const __defaultMark = getValueByPath(
    proxy.$store,
    'state.strategy.strategy.IECM_GS1_FNC1_SWEEPING_GUN',
    '96,98,105'
  )
  const __defaultMarkKey = getValueByPath(
    proxy.store,
    'state.strategy.strategy.IECM_GS1_FNC1_SWEEPING_GUN_COMBINATION',
    'altKey'
  )
  // 待识别的条码类型，eg: ['hibc', 'ma', 'gs1', 'hw']
  let __analysisType = ['hibc', 'ma', 'gs1']
  const setAnalysisType = (analysisType = __analysisType) => {
    __analysisType = analysisType
  }

  // Mark
  const getMark = () => __mark
  const getDefaultMark = () => __defaultMark
  const getDefaultMarkKey = () => __defaultMarkKey

  // 获取扫描的条码后的流程
  const __scaning = async () => {
    try {
      // console.log('扫码识别到的条码: ', data.code)
      // 扫码确认提交条形码（识别特定字符串 SCAN_SUB）
      if (/^SCAN_SUB$/i.test(data.code)) {
        data.code = ''
        // 扫码自动确认
        console.log('扫码自动确认...')
        emit('on-auto')
      } else {
        // 开始解析识别条码
        __analysing()
      }
    } catch (error) {
      console.log('--error-scaning: ', error?.message)
    }
  }

  // 解析识别条码
  const __analysing = () => {
    // 重置解析识别后的条码
    resetScanAnalysing()

    // 开始扫码解析识别
    const res = parseScanCodeUtils.scan(data.code, __analysisType)
    // console.log('解析识别后的结果: ', res)
    res.changeDisabled = changeDisabled
    if (emitInput) {
      emit('input', res)
    }
    emit('on-scan', res?.data, res)
  }

  // 前置处理扫码的条码
  const __beforeCode = async (source, replacement = 'ñ') => {
    console.log('beforeCode code: ', source)

    // 处理带有 ( 或者 [ 的不规范条码
    if (/\(|\[/.test(source)) {
      data.code = `${source}`.slice(1).replace(/\(|\[/g, replacement).replace(/\)|\]/g, '')
      return
    }

    // 什么都没处理
    data.code = source
  }

  // 获取扫描的条码
  const parsing = async (evt) => {
    let _code = evt.target.value // 获取扫码枪扫出的条码
    const keycode = evt.keyCode || evt.which || evt.charCode
    // console.log('捕获扫码后触发的事件: ', keycode, _code, evt)
    // eslint-disable-next-line vue/no-parsing-error
    // 排除某些电脑通过ASCII码直接输入分隔符， 的 ASCII 码: \x1D charCode: 29
    const regx = new RegExp(`${String.fromCharCode(29)}|\\x81`, 'g')
    if (regx.test(_code)) {
      evt.srcElement.value = evt.srcElement.value.replace(regx, '')
      _code = _code.replace(regx, '')
    }

    if (keycode == 229 || keycode == 191) {
      let myField = evt.srcElement
      if (myField.value === '???') {
        data.code = 'SCAN_SUB' // 赋值后，后续可自动确认提交
        return
      }
    }

    if (keycode == 119 || __mark?.join(',') == __defaultMark || keycode == __defaultMark) {
      let myField = evt.srcElement
      let myValue = 'ñ'
      if (myField.selectionStart || myField.selectionStart === 0) {
        let startPos = myField.selectionStart
        let endPos = myField.selectionEnd
        myField.value =
          myField.value.substring(0, startPos) +
          myValue +
          myField.value.substring(endPos, myField.value.length)
        _code = myField.value
        myField.focus()
        myField.setSelectionRange(endPos + myValue.length, endPos + myValue.length)
      }
    }

    // 处理组合键
    let markKeys = __defaultMark.split(',')
    if (markKeys) {
      let isOk = true
      markKeys.forEach((markKey) => {
        if (!evt[markKey]) {
          isOk = false
        }
      })
      if (isOk) {
        __mark.push(keycode)
      } else {
        __mark = []
      }
    }

    // Enter
    const isEneter = keycode === 13

    if (isEneter) {
      evt.srcElement.select()
      await __beforeCode(_code)
      _code = null

      // 开始解析后逻辑处理
      await __scaning()
    }
  }

  const inputType = ref('password')
  const onFocus = () => {
    inputType.value = 'password'
    setTimeout(() => {
      inputType.value = 'text'
    })
  }

  // 重置解析识别后条码
  const resetScanAnalysing = () => {
    __data.success = false
    __data.origin = null
    __data.codeType = null
    __data.print = null

    __data.data.clear()
    __data.current.clear()
  }

  // 清空识别文本框内容
  const clearInput = () => {
    data.code = ''
  }

  return {
    parsing,
    resetScanAnalysing,
    setAnalysisType,
    clearInput,
    // mark
    getMark,
    getDefaultMark,
    getDefaultMarkKey,
    onFocus,
    inputType,
  }
}
